@if (initialLoading()) {
<div
  class="flex items-center justify-center py-12"
>
  <div
    data-testid="retail-store-form-loading"
    class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
  ></div>
</div>
} @else {
<app-add-form
  data-testid="retail-store-form-add-form"
  #addForm
  [title]="config.title"
  [formFields]="translatedFormFields()"
  [headerActions]="config.headerActions"
  [sectionButtons]="config.sectionButtons || []"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [initialData]="combinedInitialData()"
  [loading]="loading()"
  (formAction)="onFormAction($event)"
  (sectionAction)="onSectionAction($event)"
></app-add-form>
}

<!-- Toast Messages -->
<p-toast data-testid="retail-store-form-toast"></p-toast>
